import { Typography } from '@corecomponents/ui'
import React, { Dispatch, SetStateAction } from 'react'
import RedTriangleSolidWarning from '@assets/images/ambassdor/Registration&login/RedTriangleSolidWarning'

type OtpInputBoxesType = {
  wrongOTP: boolean
  setWrongOTP: (val: boolean) => void
  NUM_INPUTS: number
  inputRefs: any
  otpState: boolean
  otp: any
  setOtp: Dispatch<SetStateAction<any[]>>
}

const OtpInputBoxes: React.FC<OtpInputBoxesType> = ({
  wrongOTP,
  NUM_INPUTS,
  inputRefs,
  otpState,
  otp,
  setOtp,
  setWrongOTP,
}) => {
  const handleChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value
    if (isNaN(Number(value))) {
      return
    }

    setOtp([
      ...otp.map((d: number, idx: number) => (idx === index ? value : d)),
    ])

    if (
      value !== '' &&
      index < NUM_INPUTS - 1 &&
      inputRefs[index + 1]?.current !== null
    ) {
      inputRefs[index + 1]?.current?.focus()
      setWrongOTP(false)
    }

    if (index === NUM_INPUTS - 1 && value) {
      inputRefs[index]?.current?.blur()
    }
  }

  const handleKeyDown = (
    index: number,
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === 'Backspace' && index > 0 && otp[index] === '') {
      inputRefs[index - 1]?.current?.focus()
    }
  }

  return (
    <>
      <div className={' flex justify-center '}>
        {otp.map((value: number, index: number) => {
          return (
            <>
              <input
                key={index}
                ref={inputRefs[index]}
                type="text"
                value={value}
                maxLength={1}
                onChange={(e) => handleChange(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                autoFocus={index === 0}
                className={`pl-[15px] border border-solid border-[#B7B7B7] rounded w-[40px] sm:w-[48px] h-[40px] sm:h-[48px] mx-1 my-1 font-semibold text-gray-900  text-center  focus:border-[#5A4BDA] ${
                  wrongOTP
                    ? 'border-[red]'
                    : otpState && inputRefs[index].current?.value !== ''
                    ? 'border-[green]'
                    : inputRefs[index].current?.value === '' && 'border-black'
                }`}
              />
            </>
          )
        })}
      </div>
      {wrongOTP && (
        <div className="flex justify-center gap-[6px] text-[#BF2734] text-center mt-1">
          <RedTriangleSolidWarning />
          <Typography html="OTP is incorrect." variant={'tiny'} weight={600} />
        </div>
      )}
    </>
  )
}

export default OtpInputBoxes
